<template>
  <div class="mx-3" v-if="loaded">
    <div class="row mt-4">
      <div class="col-md-12">
        <input
          class="input form-control"
          v-model="generic"
          placeholder="Pesquisar por nome"
        >
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4" v-for="payload in filterPayloads" :key="payload.name">
        <div class="card card-payload" @click="show(payload)">
          <div class="card-body text-center">
            <p><strong>{{ payload.name }}</strong></p>
            <p>
              <small>{{ payload.from }}</small> => <small>{{ payload.to }}</small>
            </p>
          </div>
        </div>
      </div>

      <Modal v-if="loaded" v-model="showModal">
        <div slot="header">
          <p><strong>{{ currentPayload.name }}</strong></p>
        </div>

        <div class="event-detail">
          <VueJsonPretty
            :data='currentPayload'
            :deep='3'
            :showLength='true'
            :showLine='true'
          />
        </div>
      </Modal>
    </div>
  </div>

  <div class="row" v-else>
    <div class="col-sm-12">
      <div class="card card-admin">
        <div class="card-body text-center">
          <p><strong>Carregando...</strong></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: { Modal, VueJsonPretty },
  computed: {
    filterPayloads() {
      if (!this.generic)
        return this.payloads

      return this.payloads.filter(payload => payload.name.toLowerCase().includes(this.generic.toLowerCase()))
    }
  },
  created() {
    this.getPayloads()
  },
  data: () => ({
    currentPayload: {},
    loaded: false,
    payloads: [],
    showModal: false,
    generic: ''
  }),
  methods: {
    getPayloads() {
      this.axios.get('/admin/payloads')
        .then(response => this.payloads = response.data)
        .finally(() => this.loaded = true)
    },
    show(payload) {
      this.currentPayload = payload
      this.showModal = true
    }
  },
  name: 'Payload'
}
</script>

<style scoped>

.card-payload {
  cursor: pointer;
}
.card-payload:hover {
  transition: background-color 1s;
  background: #8080803d;
}
.event-detail * {
  background: #051724;
  color: #FFF;
  padding: 16px;
  border-radius: 8px;
}

</style>